//批量流转
import React from 'react'
import { connect } from 'react-redux'

class BachConfirmDiv extends React.Component {
    state = {
        errorMessage: null,
        changedValues基本信息: {},
        initValues基本信息: {}
    }

    handlerSave = () => {
        const { onSave, onClose, ids } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'BatchConfirm',
            data: {
                ids,
                changedValues基本信息
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('确认成功')
                onSave && onSave()
                onClose && onClose()
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return values.确认意见
    }

    fieldset基本信息 = () => {
        return [
            { _text: '确认意见', maxRows: 3 },
        ]
    }
    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="800"
            controls={
                [
                    { _button: '同意', icon: 'save', handler: this.handlerSave, },
                    { _button: '取消', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}
export default connect()(BachConfirmDiv)